import { Http, All, Spread, CancelToken } from './base'
import Auth from '@/common/auth'
import router from '@/router'
import options from '@/config'

const defaultContentType = 'application/json'

const beforeMutatorsSuccess = config => {
  const headerOrDefault = (header, defaultValue = '') => {
    if (config.headers && config.headers[header]) {
      return config.headers[header]
    }
    return defaultValue
  }

  config.headers['Accept'] = headerOrDefault('Accept', defaultContentType)
  config.headers['Content-Type'] = headerOrDefault('Content-Type', defaultContentType)

  const token = Auth.GetToken()
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
}

const afterMutatorError = error => {
  let route = router.currentRoute

  if (error.response && error.response.status === 401 &&
    route.meta && route.meta.requiresLogin) {
    Auth.Logout()

    return
  }

  return Promise.reject(error)
}

const apiOptions = {
  apiUrl: options.apiUrl,
  beforeMutators: {
    success: beforeMutatorsSuccess
  },
  afterMutators: {
    error: afterMutatorError
  }
}

export default {
  api: Http(apiOptions),
  helpers: {
    all: All,
    spread: Spread
  },
  cancelToken: CancelToken
}



// WEBPACK FOOTER //
// ./src/common/http/index.js